import styles from './footer.module.css'
import { useSystemStateHooks } from '../../../../modules/system'

export const Footer = () => {
  const { hasCompanyAccess } = useSystemStateHooks()

  return (
    <footer id="footer" className={`footer ${hasCompanyAccess() ? '' : styles.noMargin}`}>
      <div className="copyright">
        &copy; Copyright <strong><span>Construfy</span></strong>
      </div>
    </footer>
  )
}
